// extracted by mini-css-extract-plugin
export var linkCard = "blogInfoCard-module--linkCard--xZ7jb";
export var cardContent = "blogInfoCard-module--cardContent--imMud";
export var cardList = "blogInfoCard-module--cardList--1KEd-";
export var readMore = "blogInfoCard-module--readMore--ApVED";